var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogo = function SvgLogo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.4 74.9",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8 2.8h74.4v74.9H2.8z",
    "data-name": "Rechteck 1844"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 5963"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__a)",
    "data-name": "Gruppe 5959",
    transform: "translate(-2.8 -2.8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#023e84",
    d: "M77.7 34.4V3.3a.472.472 0 0 0-.5-.5H46.1a.472.472 0 0 0-.5.5v7.5a.634.634 0 0 0 .5.6 29.02 29.02 0 0 1 23 23 .634.634 0 0 0 .6.5h7.5a.536.536 0 0 0 .5-.5",
    "data-name": "Pfad 3145"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__a)",
    "data-name": "Gruppe 5960",
    transform: "translate(-2.8 -2.8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#023e84",
    d: "M34.9 34.4V3.3a.472.472 0 0 0-.5-.5h-7.5a.634.634 0 0 0-.6.5c-1.2 10.6-11.5 20.9-23 23a.634.634 0 0 0-.5.6v7.5a.472.472 0 0 0 .5.5h31.1a.472.472 0 0 0 .5-.5",
    "data-name": "Pfad 3146"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__a)",
    "data-name": "Gruppe 5961",
    transform: "translate(-2.8 -2.8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#023e84",
    d: "M34.9 77.2v-7.5a.634.634 0 0 0-.5-.6c-10.6-1.3-20.9-11.5-23-23a.634.634 0 0 0-.6-.5H3.3a.472.472 0 0 0-.5.5v31.1a.472.472 0 0 0 .5.5h31.1a.472.472 0 0 0 .5-.5",
    "data-name": "Pfad 3147"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__a)",
    "data-name": "Gruppe 5962",
    transform: "translate(-2.8 -2.8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fa7d19",
    d: "M77.7 53.6v-7.5a.472.472 0 0 0-.5-.5H46.1a.472.472 0 0 0-.5.5v31.1a.472.472 0 0 0 .5.5h7.5a.634.634 0 0 0 .6-.5 29.02 29.02 0 0 1 23-23 .56.56 0 0 0 .5-.6",
    "data-name": "Pfad 3148"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export default ForwardRef;